export enum ChartAxisType {
  Line = 0,
  StackedArea = 1,
  SignedStackedArea = 2
}
